import { componentTypes, Schema } from '@data-driven-forms/react-form-renderer';
import { GridProps } from '@mui/system';

export interface BrandSchemaData {
  brandName: string,
  editData?: any,

}

// xs, sm, md, lg, xl: Define the number of grid columns the item should span at different breakpoints (e.g., xs: 6 means the item spans 6 out of 12 columns on extra-small screens).
// spacing: Defines the space between grid items.
//   alignItems: Aligns items vertically (e.g., flex-start, center, flex-end).
//   justifyContent: Aligns items horizontally (e.g., flex-start, center, space-between).
//   direction: Defines the direction of the grid (e.g., row, column).
export const BrandSchema  = (props: BrandSchemaData) => {
  const {
    brandName,
    editData,
  } = props;
  return {
    fields: [
      {
        component: componentTypes.TEXT_FIELD,
        label: 'Brand Name',
        placeholder: 'Brand Name',
        name: 'brandName',
        required: true,
        disabled: false,
        initialValue: editData?.name,
        validate: [{
          type: 'required',
          message: 'Brand name is required'
        }]
      }
    ]
  } as Schema extends GridProps ? GridProps : never;
};
